import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const attendanceSet = {
  pageTabs: [
    {
      label: '考勤组',
      theme: 'attendanceSet',
      step: 'attendanceGroupList',
      stepLabel: '考勤组列表',
      checkFun: 'attendanceSet/getAttendanceGroupList'
    },
    {
      label: '考勤区域',
      theme: 'attendanceSet',
      step: 'attendanceAreaList',
      stepLabel: '考勤区域列表',
      checkFun: 'attendanceSet/getAttendanceAreaList'
    }
  ],
  attendanceGroup: {
    name: 'attendanceGroup',
    theme: '考勤组',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'attendanceSet/addAttendanceGroup',
    editFun: 'attendanceSet/editAttendanceGroup',
    getListFun: 'attendanceSet/getAttendanceGroupList',
    getDetailFun: 'attendanceSet/getAttendanceGroupInfo',
    deleteFun: 'attendanceSet/deleteAttendanceGroup',
    detailPage: [
      {
        buttonName: '新增',
        type: 'stepForm',
        name: 'attendanceGroup',
        step: 'attendanceGroupInfo',
        theme: 'attendanceSet',
        label: '新增考勤组'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'attendanceGroup',
        step: 'attendanceGroupInfo',
        theme: 'attendanceSet',
        label: '编辑考勤组',
        checkType: 'checkByUid',
        checkFun: 'attendanceSet/getAttendanceGroupInfo'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      checkingName: ''
    },
    selectData: [
      {
        key: 'checkingName',
        label: '关键词',
        type: 'input',
        placeholder: '考勤组名称',
        clearable: false
      }
    ],
    rowData: (params) => {
      return params.state.attendanceSet.attendanceGroupList.result
    },
    rowTotal: (params) => {
      return params.state.attendanceSet.attendanceGroupList.totalSize
    },
    columns: [
      { prop: 'checkingName', label: '考勤组名称', width: '160px' },
      {
        prop: 'checkingOrg',
        label: '参与考勤机构',
        width: '700px',
        overflow: false
      },
      {
        prop: 'checkingTwice',
        label: '考勤班次',
        tag: (params) => {
          return params.dictionarys.checkingTwice
        }
      },
      { prop: 'dateTime', label: '最近更新时间', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      checkingName: '',
      joinOrgStr: '',
      joinOrgUids: [],
      checkingTwice: '每天一次',
      allowSupplement: true,
      // 界面不展示；入库默认全开（不限方式）
      checkingType: [
        '电子围栏定位',
        '门禁打卡',
        '考勤机打卡',
        'web手动打卡',
        '班前教育打卡'
      ],
      allowMaxNum: 0,
      allowAgoDay: '',
      areas: []
    },
    formRules: {
      checkingName: [
        {
          required: true,
          message: '请输入考勤组名称',
          trigger: 'blur'
        }
      ],
      joinOrgStr: [
        {
          required: true,
          message: '请选择考勤机构',
          trigger: 'input'
        }
      ],
      areas: [
        {
          required: true,
          message: '请选择考勤区域',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '考勤组信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'checkingName',
          label: '考勤组名称',
          type: 'input'
        },
        {
          key: 'joinOrgStr',
          label: '参与考勤机构',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 3, maxRows: 5 },
          placeholder: '点击选择相关考勤机构'
        },
        {
          key: 'areas',
          label: '考勤区域',
          type: 'select',
          options: (params) => {
            return params.state.attendanceSet.attendanceAreaList
          },
          placeholder: '请选择相关的允许考勤区域，可多选',
          checkByValue: true,
          multiple: true
        }
      ]
    }
  },
  attendanceArea: {
    name: 'attendanceArea',
    theme: '考勤区域',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    checkType: 'useRowData',
    addFun: 'attendanceSet/addAttendanceArea',
    editFun: 'attendanceSet/editAttendanceArea',
    getListFun: 'attendanceSet/getAttendanceAreaList',
    deleteFun: 'attendanceSet/deleteAttendanceArea',
    deleteConfirm: (params) => {
      const name =
        (params.row && (params.row.fenceName || params.row.label)) || '该考勤区域'
      return '此操作将永久删除「' + name + '」, 是否继续?'
    },
    detailPage: [
      {
        buttonName: '新增',
        type: 'stepForm',
        name: 'attendanceArea',
        step: 'attendanceAreaInfo',
        theme: 'attendanceSet',
        label: '新增考勤区域'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'attendanceArea',
        step: 'attendanceAreaInfo',
        theme: 'attendanceSet',
        label: '编辑考勤区域',
        checkType: 'useRowData'
      }
    ],
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      name: ''
    },
    selectData: [
      {
        key: 'name',
        label: '关键词',
        type: 'input',
        placeholder: '考勤区域名称',
        clearable: false
      }
    ],
    headButtons: setCheckButtons(['新增']),
    rowButtons: setTableButtons([
      '编辑',
      '删除',
      { name: '预览', code: 'mapPreview' }
    ]),
    rowData: (params) => {
      return params.state.attendanceSet.attendanceAreaList
    },
    columns: [
      { prop: 'fenceName', label: '考勤区域名称', width: '280px' },
      {
        prop: 'areaType',
        label: '区域类型',
        width: '280px'
      },
      { prop: 'fenceBuffer', label: '区域范围(m)', width: '' },
      { prop: 'createUserName', label: '创建人', width: '140px' },
      {
        label: '操作',
        buttons: setTableButtons([
          '编辑',
          '删除',
          { name: '预览', code: 'mapPreview' }
        ]),
        width: '280px'
      }
    ],
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      uid: '',
      fenceName: (params) => {
        const list = (params.state.attendanceSet &&
          params.state.attendanceSet.attendanceAreaList) || []
        let max = 0
        list.forEach((item) => {
          const matched = String((item && item.fenceName) || '').match(
            /考勤区域(\d+)/
          )
          if (matched) {
            const num = parseInt(matched[1], 10)
            if (!Number.isNaN(num) && num > max) max = num
          }
        })
        return '考勤区域' + (max + 1)
      },
      dataType: 'point',
      fenceBuffer: 1000,
      fenceType: 'work_attendance',
      lnglats: [],
      coordinates: []
    },
    formRules: {
      fenceName: [
        {
          required: true,
          message: '请输入考勤区域名称',
          trigger: 'blur'
        }
      ],
      dataType: [
        {
          required: true,
          message: '请选择区域类型',
          trigger: 'blur'
        }
      ],
      fenceBuffer: [
        {
          required: (params) => {
            return params.formValues && params.formValues.dataType !== 'area'
          },
          message: '请输入区域半径',
          trigger: 'blur'
        }
      ],
      lnglats: [
        {
          validator: (params) => {
            return params.validate.validateCoordinates
          },
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '考勤区域信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'fenceName',
          label: '考勤区域名称',
          type: 'input'
        },
        {
          key: 'dataType',
          label: '考勤区域类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.attendanceAreaType
          },
          checkByValue: true
        },
        {
          key: (params) => {
            return params.formValues && params.formValues.dataType !== 'area'
              ? 'fenceBuffer'
              : ''
          },
          label: '考勤区域半径',
          type: 'input',
          inputButton: 'm'
        },
        {
          key: 'lnglats',
          label: '考勤区域点位',
          type: 'table',
          // 表头 + 5 行操作列（约 48px/行），略留余量避免第 5 行被裁切
          maxHeight: 320,
          headButtons: setCheckButtons([
            { name: '添加点位及预览', code: 'addPoint' }
          ]),
          columns: [
            { prop: 'label', label: '点位', width: '90px' },
            { prop: 'lnglat', label: '经纬度' },
            {
              label: '操作',
              buttons: setTableButtons([
                '上移',
                '下移',
                { name: '删除', code: 'removePoint' }
              ]),
              width: '280px'
            }
          ]
        }
      ]
    }
  }
}

export default attendanceSet
